import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledMarkdown } from "./markdown.scss";
import DefaultProps from "./default-props";
import dynamic from "next/dynamic";
const ReactMarkdown = dynamic(()=>import("react-markdown/with-html"));
const CodeBlock = dynamic(()=>import("./codeblock"));
class Markdown extends PureComponent {
    render() {
        const { input } = this.props;
        return /*#__PURE__*/ _jsx(StyledMarkdown, {
            className: "markdown",
            children: /*#__PURE__*/ _jsx(ReactMarkdown, {
                source: input,
                escapeHtml: false,
                renderers: {
                    code: CodeBlock
                }
            })
        });
    }
}
export { Markdown as default };
Markdown.defaultProps = DefaultProps;
